import { http } from '@/http/axios.js'
// 地址树
export function getAreaTree(params) {
  return http({
    url: '/api/manage/staff/area/tree',
    method: 'GET',
    params
  })
}
